export default {
	apiKeyCometChat: '046cd5bdf73e8c00737c32ca9499e15313e405ce',
	appIdCometChat: '23008e0be3977b5'
}